module.exports = __webpack_public_path__ + "static/media/split_page_mock.e3a1b4d9.jpg";